// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fWTL","tabsBox":"styles_tabsBox__1qK-Q","createButton":"styles_createButton__2ASX3"};